import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import createMultiTabState from 'vuex-multi-tab-state';
import serverError from './modules/serverError.js';
import auth from './modules/auth/auth.js';
import locale from './modules/locale.js';
import cart from './modules/cart.js';
import currency from './modules/currency.js';
import siteSettings from './modules/siteSettings.js';
import siteFunctionality from './modules/siteFunctionality.js';
import snackbar from './modules/snackbar';

Vue.use(Vuex);

const store = new Vuex.Store({
  plugins: [
    createPersistedState({
      paths: [
        'auth',
        'locale',
        'cart.currentCart',
        'cart.cartOwner',
        'cart.buyNowOrder',
        'cart.buyNowBook',
        'currency',
        'siteSettings',
        'siteFunctionality',
      ],
    }),
    createMultiTabState({
      statesPaths: [
        'auth',
        'locale',
        'cart.currentCart',
        'cart.cartOwner',
        'currency',
        'siteSettings',
      ],
    }),
  ],
  modules: {
    serverError,
    auth,
    locale,
    cart,
    currency,
    siteSettings,
    siteFunctionality,
    snackbar,
  },
});

export default store;